import { createTypes, createAction } from 'lib/action'

// *load ข้อมูลต้นแหล่ง
const LAB_QUALITY_EVALUATION_LOCATION = createTypes(
  'labQualityEvaluationLoadLocation',
  'load'
)

// *laod ข้อมูลวัตถุดิบ
const LAB_QUALITY_EVALUATION_RAW_MATERIAL = createTypes(
  'labQualityEvaluationLoadMaterial',
  'load'
)

// *load ข้อมูล form ประเมินคุณภาพ
const LAB_QUALITY_EVALUATION_REQUEST_FORM = createTypes(
  'labQualityEvaluationLoadRequestForm',
  'load'
)

// *load table log ประเมินคุณภาพ
const LAB_QUALITY_EVALUATION_TABLE_LOG = createTypes(
  'labQualityEvaluationLoadTableLog',
  'load'
)

// *load detail ประเมินคุณภาพ
const LAB_QUALITY_EVALUATION_DETAIL = createTypes(
  'labQualityEvaluationLoadDetail',
  'load'
)

// *create form ประเมินคุณภาพ
const LAB_QUALITY_EVALUATION_CREATE = createTypes(
  'labQualityEvaluationCreateForm',
  'create'
)

// *ลบ form ประเมินคุณภาพ
const LAB_QUALITY_EVALUATION_DELETE = createTypes(
  'labQualityEvaluationDeleteForm',
  'delete'
)

// *calculate form ประเมินคุณภาพ
const LAB_QUALITY_EVALUATION_CALCULATE = createTypes(
  'labQualityEvaluationCalculateForm',
  'load'
)

// *export 1 form ประเมินคุณภาพ
const LAB_QUALITY_EVALUATION_EXPORT_ONE_FORM = createTypes(
  'labQualityEvaluationExportOneForm',
  'export'
)

// *export หลาย form ประเมินคุณภาพ
const LAB_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM = createTypes(
  'labQualityEvaluationExportMultipleForm',
  'export'
)

// *load division
const LAB_QUALITY_EVALUATION_LOAD_DIVISION = createTypes(
  'labQualityEvaluationLoadDivision',
  'load'
)

// *load department
const LAB_QUALITY_EVALUATION_LOAD_DEPARTMENT = createTypes(
  'labQualityEvaluationLoadDepartment',
  'load'
)

// *load section
const LAB_QUALITY_EVALUATION_LOAD_SECTION = createTypes(
  'labQualityEvaluationLoadSection',
  'load'
)

// *load plant
const LAB_QUALITY_EVALUATION_LOAD_PLANT = createTypes(
  'labQualityEvaluationLoadPlant',
  'load'
)

// *load ข้อมูลสถานที่ต้นแหล่ง โรงงานสำหรับฟอร์มประเมิน
const LAB_QUALITY_EVALUATION_LOAD_LOCATION_FORM = createTypes(
  'labQualityEvaluationLoadLocationForm',
  'load'
)

// *load ข้อมูลศูนย์ทดสอบ
const LAB_QUALITY_EVALUATION_TEST_CENTER = createTypes(
  'labQualityEvaluationLoadTestCenter',
  'load'
)

// *edit form ประเมินคุณภาพ
const LAB_QUALITY_EVALUATION_EDIT = createTypes(
  'labQualityEvaluationEditForm',
  'update'
)

// *export excel
const LAB_QUALITY_EVALUATION_EXPORT_EXCEL = createTypes(
  'labQualityEvaluationExportExcel',
  'export'
)

// *get user can add
const LAB_QUALITY_EVALUATION_GET_USER_CAN_ADD = createTypes(
  'labQualityEvaluationGetUserCanAdd',
  'load'
)

// *remove lists
const REMOVE_LISTS = `REMOVE_LISTS`

// *remove lists
function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

// *load ข้อมูลต้นแหล่ง
const labQualityEvaluationLoadLocation = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_LOCATION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_LOCATION.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_LOCATION.FAITLURE),
}

// *load ข้อมูลวัตถุดิบ
const labQualityEvaluationLoadRawMaterial = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_RAW_MATERIAL.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_RAW_MATERIAL.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_RAW_MATERIAL.FAITLURE),
}

// *load table log ประเมินคุณภาพ
const labQualityEvaluationLoadTableLog = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_TABLE_LOG.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_TABLE_LOG.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_TABLE_LOG.FAITLURE),
}

// *load ข้อมูล form ประเมินคุณภาพ
const labQualityEvaluationLoadRequestForm = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_REQUEST_FORM.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_REQUEST_FORM.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_REQUEST_FORM.FAITLURE),
}

// *load detail ประเมินคุณภาพ
const labQualityEvaluationLoadDetail = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_DETAIL.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_DETAIL.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_DETAIL.FAITLURE),
}

// *create form ประเมินคุณภาพ
const labQualityEvaluationCreateForm = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_CREATE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_CREATE.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_CREATE.FAITLURE),
}

// *ลบ form ประเมินคุณภาพ
const labQualityEvaluationDeleteForm = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_DELETE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_DELETE.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_DELETE.FAITLURE),
}

// *calculate form ประเมินคุณภาพ
const labQualityEvaluationCalculateForm = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_CALCULATE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_CALCULATE.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_CALCULATE.FAITLURE),
}

// *export 1 form ประเมินคุณภาพ
const labQualityEvaluationExportOneForm = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_EXPORT_ONE_FORM.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_EXPORT_ONE_FORM.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_EXPORT_ONE_FORM.FAITLURE),
}

// *export หลาย form ประเมินคุณภาพ
const labQualityEvaluationExportMultipleForm = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(LAB_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM.FAITLURE),
}

// *load division
const labQualityEvaluationLoadDivision = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_DIVISION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_DIVISION.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_LOAD_DIVISION.FAITLURE),
}

// *load department
const labQualityEvaluationLoadDepartment = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_DEPARTMENT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_DEPARTMENT.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_LOAD_DEPARTMENT.FAITLURE),
}

// *load section
const labQualityEvaluationLoadSection = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_SECTION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_SECTION.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_LOAD_SECTION.FAITLURE),
}

// *load plant
const labQualityEvaluationLoadPlant = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_PLANT.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_LOAD_PLANT.FAITLURE),
}

// *load ข้อมูลสถานที่สำหรับต้นแหล่ง โรงงานสำหรับฟอร์มประเมินคุณภาพ
const labQualityEvaluationLoadLocationForm = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_LOCATION_FORM.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_LOCATION_FORM.SUCCESS, { lists }),
  failure: () =>
    createAction(LAB_QUALITY_EVALUATION_LOAD_LOCATION_FORM.FAITLURE),
}

// *load ข้อมูล test center
const labQualityEvaluationLoadTestCenter = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_TEST_CENTER.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_TEST_CENTER.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_TEST_CENTER.FAITLURE),
}

// *export excel
const labQualityEvaluationExportExcel = {
  request: (data) =>
    createAction(LAB_QUALITY_EVALUATION_EXPORT_EXCEL.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_EXPORT_EXCEL.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_EXPORT_EXCEL.FAITLURE),
}

// *edit form ประเมินคุณภาพ
const labQualityEvaluationEditForm = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_EDIT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_EDIT.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_EDIT.FAITLURE),
}

// *get user can add
const labQualityEvaluationGetUserCanAdd = {
  request: (data, loading) =>
    createAction(LAB_QUALITY_EVALUATION_GET_USER_CAN_ADD.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(LAB_QUALITY_EVALUATION_GET_USER_CAN_ADD.SUCCESS, { lists }),
  failure: () => createAction(LAB_QUALITY_EVALUATION_GET_USER_CAN_ADD.FAITLURE),
}

export {
  LAB_QUALITY_EVALUATION_LOCATION,
  labQualityEvaluationLoadLocation,
  LAB_QUALITY_EVALUATION_RAW_MATERIAL,
  labQualityEvaluationLoadRawMaterial,
  LAB_QUALITY_EVALUATION_TABLE_LOG,
  labQualityEvaluationLoadTableLog,
  LAB_QUALITY_EVALUATION_REQUEST_FORM,
  labQualityEvaluationLoadRequestForm,
  LAB_QUALITY_EVALUATION_DETAIL,
  labQualityEvaluationLoadDetail,
  LAB_QUALITY_EVALUATION_CREATE,
  labQualityEvaluationCreateForm,
  LAB_QUALITY_EVALUATION_DELETE,
  labQualityEvaluationDeleteForm,
  LAB_QUALITY_EVALUATION_CALCULATE,
  labQualityEvaluationCalculateForm,
  LAB_QUALITY_EVALUATION_EXPORT_ONE_FORM,
  labQualityEvaluationExportOneForm,
  LAB_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM,
  labQualityEvaluationExportMultipleForm,
  LAB_QUALITY_EVALUATION_LOAD_DIVISION,
  labQualityEvaluationLoadDivision,
  LAB_QUALITY_EVALUATION_LOAD_DEPARTMENT,
  labQualityEvaluationLoadDepartment,
  LAB_QUALITY_EVALUATION_LOAD_SECTION,
  labQualityEvaluationLoadSection,
  LAB_QUALITY_EVALUATION_LOAD_PLANT,
  labQualityEvaluationLoadPlant,
  LAB_QUALITY_EVALUATION_LOAD_LOCATION_FORM,
  labQualityEvaluationLoadLocationForm,
  LAB_QUALITY_EVALUATION_TEST_CENTER,
  labQualityEvaluationLoadTestCenter,
  LAB_QUALITY_EVALUATION_EDIT,
  labQualityEvaluationEditForm,
  LAB_QUALITY_EVALUATION_EXPORT_EXCEL,
  labQualityEvaluationExportExcel,
  LAB_QUALITY_EVALUATION_GET_USER_CAN_ADD,
  labQualityEvaluationGetUserCanAdd,
  REMOVE_LISTS,
  removeLists,
}
